import apiClient from './client';
import type {
  CreateDonationRequest,
  CreateDonationResponse,
  VerifyDonationResponse,
  Donation,
  GivingOptionsResponse,
} from '@/types/donation';
import type { PaymentOptionsResponse } from '@/types/region';

interface PaymentOptionsParams {
  region?: string;
  currency?: string;
  locale?: string;
  timezone?: string;
}

export async function getPaymentOptions(
  params: PaymentOptionsParams
): Promise<PaymentOptionsResponse> {
  return apiClient.get('/api/donations/payment-options', { params });
}

export async function createDonation(
  data: CreateDonationRequest
): Promise<CreateDonationResponse> {
  return apiClient.post('/api/donations', data);
}

export async function verifyDonation(donationId: string): Promise<VerifyDonationResponse> {
  return apiClient.post(`/api/donations/${donationId}/verify`);
}

export async function getDonation(donationId: string): Promise<{ success: boolean; data: Donation }> {
  return apiClient.get(`/api/donations/${donationId}`);
}

export async function getGivingOptions(
  params: PaymentOptionsParams
): Promise<GivingOptionsResponse> {
  return apiClient.get('/api/donations/giving-options', { params });
}
